import { all } from "redux-saga/effects";
import appSaga from './saga/appSaga';
import authSaga from './saga/authSaga';

export default function* rootSaga() {
  yield all([
    appSaga(),
    authSaga(),
  ]);
}
